import React, { useEffect, useState, useCallback } from 'react';
import ModalFormPqr from '../../components/forms/pqr/modal.form.pqr';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Row, Col, Form, Button, Container } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
import DirectionPathButton from '../../components/widgets/directionPathButton';

const STATE_OPTIONS = [
  { value: 'pending', label: 'Pendiente' },
  { value: 'in_progress', label: 'En Proceso' },
  { value: 'resolved', label: 'Resuelto' },
  { value: 'closed', label: 'Cerrado' },
  { value: 'cancelled', label: 'Cancelado' },
];

function ListPqr() {
  const [msgGet, setMsgGet] = useState('');
  const [pqrList, setPqrList] = useState([]);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [filters, setFilters] = useState({
    state: '',
    type: '',
    priority: '',
    search: '',
    init_date: '',
    end_date: '',
  });

  const getPqr = useCallback(async (filterParams = {}) => {
    const params = {};
    if (filterParams.state) params.state = filterParams.state;
    if (filterParams.type) params.type = filterParams.type;
    if (filterParams.priority) params.priority = filterParams.priority;
    if (filterParams.search) params.search = filterParams.search;
    if (filterParams.init_date) params.init_date = filterParams.init_date;
    if (filterParams.end_date) params.end_date = filterParams.end_date;

    const response = await get('/pqr/', {}, params);
    if (response.success) {
      setPqrList(response.data);
    } else {
      setMsgGet(response.message);
    }
  }, []);

  useEffect(() => {
    getPqr({});
  }, [getPqr]);

  const createPqr = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getPqr(filters);
  };

  const handleFilterChange = ({ target }) => {
    setFilters((prev) => ({ ...prev, [target.name]: target.value }));
  };

  const applyFilters = () => {
    getPqr(filters);
  };

  const clearFilters = () => {
    const empty = { state: '', type: '', priority: '', search: '', init_date: '', end_date: '' };
    setFilters(empty);
    getPqr(empty);
  };

  const editButton = (row) => {
    return (
      <Row className="g-1">
        <Col xs="auto">
          <DirectionPathButton
            path={'/pqr/detail/' + row.id}
            variant="outline-info"
            text="Ver"
          />
        </Col>
        <Col xs="auto">
          <ModalFormPqr
            title="Editar PQR"
            button_text="Editar"
            button_variant="outline-primary"
            pqrSelect={row.id}
            callback={createPqr}
          />
        </Col>
      </Row>
    );
  };

  return (
    <Base>
      {alert.show && (
        <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>
          {alert.message}
        </Alert>
      )}

      <ModalFormPqr
        title="Crear PQR"
        button_text="Crear PQR"
        button_variant="primary"
        callback={createPqr}
      />

      <Container className="p-4">
        <Form>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Estado</Form.Label>
                <Form.Select name="state" value={filters.state} onChange={handleFilterChange}>
                  <option value="">Todos</option>
                  {STATE_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Prioridad</Form.Label>
                <Form.Select name="priority" value={filters.priority} onChange={handleFilterChange}>
                  <option value="">Todas</option>
                  <option value="low">Baja</option>
                  <option value="medium">Media</option>
                  <option value="high">Alta</option>
                  <option value="urgent">Urgente</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Buscar (Radicado)</Form.Label>
                <Form.Control
                  name="search"
                  value={filters.search}
                  type="text"
                  onChange={handleFilterChange}
                  placeholder="PQR-..."
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Fecha Inicio</Form.Label>
                <Form.Control
                  name="init_date"
                  value={filters.init_date}
                  type="date"
                  onChange={handleFilterChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Fecha Fin</Form.Label>
                <Form.Control
                  name="end_date"
                  value={filters.end_date}
                  type="date"
                  onChange={handleFilterChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={3}>
              <Button onClick={applyFilters} variant="outline-primary" className="w-100">
                Buscar
              </Button>
            </Col>
            <Col md={3}>
              <Button onClick={clearFilters} variant="outline-secondary" className="w-100">
                Limpiar
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>

      <ListTables
        data={pqrList}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListPqr;
